export var REDIRECT_URI_REGEX = /^(?:https:\/\/[a-zA-Z0-9-.]+|http:\/\/(?:127\.0\.0\.1|localhost)):?(?:[0-9]+)?(\/|$)/;
export function isValidRedirectUri(uri) {
    return REDIRECT_URI_REGEX.test(uri);
}
